// extracted by mini-css-extract-plugin
export default {"modalCont":"AddDoctorStaffModal_modalCont__Cutfh"};